import { SVGProps } from 'react';

export const EmbedIcon = (props: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="0.9em"
    viewBox="0 0 24 24"
    width="1em"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 14h6" />
    <path d="M4 2h10" />
    <rect x="4" y="18" width="16" height="4" rx="1" />
    <rect x="4" y="6" width="16" height="4" rx="1" />
  </svg>
);
